import {
  ApiParams,
  BaseClient,
  IActionResponse,
  IActionResult,
  IPagedResult,
} from "../../../assets/utils/lib";
import { NewsFeedDto, SearchNewsFeedDto } from "../../dto";

export class NewsFeedClient extends BaseClient {
  routes = ["pophub", "NewsFeed"];
  async getNewsFeedAsync(id: string | undefined): Promise<NewsFeedDto> {
    const actions: string[] = ["GetNewsFeed"];
    const params: ApiParams[] = [new ApiParams("id", id, true)];
    const result: NewsFeedDto = await this.getAsync<NewsFeedDto>(
      actions,
      params
    );
    return result;
  }
  async searchNewsFeedAsync(
    payload: SearchNewsFeedDto | undefined
  ): Promise<IPagedResult<NewsFeedDto>> {
    const actions: string[] = ["SearchNewsFeed"];
    const result: IPagedResult<NewsFeedDto> = await this.postAsync<
      SearchNewsFeedDto,
      NewsFeedDto,
      IPagedResult<NewsFeedDto>
    >(actions, payload);
    return result;
  }
  async saveNewsFeedAsync(
    payload: NewsFeedDto | undefined
  ): Promise<IActionResult<NewsFeedDto>> {
    const actions: string[] = ["SaveNewsFeed"];
    return await this.postAsync<NewsFeedDto>(actions, payload);
  }
  async deleteNewsFeedAsync(id?: string | undefined): Promise<IActionResponse> {
    const actions: string[] = ["DeleteNewsFeed"];
    const params: ApiParams[] = [new ApiParams("id", id, true)];
    return await this.deleteAsync(actions, params);
  }
}
